import * as dd from 'dingtalk-jsapi';
import * as userApi from './../api/userApi'
import datepicker$ from 'dingtalk-jsapi/api/biz/util/datepicker';

Date.prototype.format = function(fmt) {
     var o = {
        "M+" : this.getMonth()+1,                 //月份
        "d+" : this.getDate(),                    //日
        "h+" : this.getHours(),                   //小时
        "m+" : this.getMinutes(),                 //分
        "s+" : this.getSeconds(),                 //秒
        "q+" : Math.floor((this.getMonth()+3)/3), //季度
        "S"  : this.getMilliseconds()             //毫秒
    };
    if(/(y+)/.test(fmt)) {
            fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
    }
     for(var k in o) {
        if(new RegExp("("+ k +")").test(fmt)){
             fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
         }
     }
    return fmt;
}

export default {

    getUrlQuery: (name) => {
        if (typeof name !== 'string') {
            console.error('name参数应该为string')
        }
        const url = location.href
        const query = url.substring(url.indexOf('?') + 1).split('&')
        let result
        for (let i = 0; i < query.length; i++) {
            if (query[i].indexOf(`${name}=`) > -1) {
                result = query[i].split(`${name}=`)[1]
                break
            }
        }
        if (result) return result
        else {
            console.log(`${name} 参数不存在`)
            return ''
        }
    },
    getCookie: (cName) => {
        let cStart
        let cEnd
        if (document.cookie.length > 0) {
            cStart = document.cookie.indexOf(cName + '=')
            if (cStart !== -1) {
                cStart = cStart + cName.length + 1
                cEnd = document.cookie.indexOf(';', cStart)
                if (cEnd === -1) cEnd = document.cookie.length
                return unescape(document.cookie.substring(cStart, cEnd))
            }
        }
        return ''
    },
    setCookie: (cname, cvalue, exdays) => {
        var d = new Date()
        d.setTime(d.getTime() + (exdays || 1 * 24 * 60 * 60 * 1000))
        var expires = 'expires=' + d.toUTCString()
        document.cookie = cname + '=' + cvalue + '; ' + expires
    },
    getLS: (key) => {
        var ls = window.localStorage
        if (ls.getItem(key)) {
            return ls.getItem(key)
        } else {
            return ''
        }
    },
    setLS: (key, value) => {
        var ls = window.localStorage
        ls.setItem(key, value)
    },
    removeLS: (key) => {
        var ls = window.localStorage
        ls.removeItem(key)
    },
    clearLS: () => {
        var ls = window.localStorage
        ls.clear()
    },
    pubErr: function(curr, res, sfn, ffn) { //统一错误处理
        const self = curr;
        if (res.Status == true) {
            sfn(res);
            if (self.hasOwnProperty('debug') && self.debug) { console.log(res); if (!!res.Data) { console.log(res.Data.SysNo); } }
        } else {
            ffn(res);
            // self.$layer.msg("失败："+res.Message);
            if (self.hasOwnProperty('debug') && self.debug) { console.log(res); }
        }
    },
    vf: function(curr, currOrder) { // 此方法主要用于订单明细页面权限控制，不见得会适合列表页面
        var user = curr.$store.getters['Account/user'];

        if (!!user) {
            curr.isMaster = false; //是否商户
            curr.isStoreMag = false; //是否门店，需结合给定订单门店号/状态（在给定门店下是门店管理员）（可驳回）
            curr.isRepairMag = false; //是否维修师，需结合给定订单门店号/状态（在给定门店下是维修师）（可接单，改联系人，改预约）
            curr.isMyOrderMag = false; //是否当前订单维修师，需结合给定订单门店号/状态，和维修师id（可弃，结，付，改项，验码，）
            if (user.IsMaster) {
                curr.isMaster = true;
            }
            if (!!user.StoreNetworkIdList && user.StoreNetworkIdList.length > 0) {
                // 给定订单门店 在当前用户 门店管理权限 门店范围内（此订单用户可驳回）
                if (user.StoreNetworkIdList.indexOf(currOrder.ServiceShopNo) >= 0) { curr.isStoreMag = true; }
            }
            if (!!user.RepairNetworkIdList && user.RepairNetworkIdList.length > 0) {
                // 给定订单门店 在当前用户 维修师权限 门店范围内（此订单用户可接单，修改联系人）
                if (user.RepairNetworkIdList.indexOf(currOrder.ServiceShopNo) >= 0) {
                    // 当前订单维修师是当前用户，前提是该订单门店 还在维修师门店列表内
                    if (user.UserId === currOrder.RepairBy) {
                        curr.isMyOrderMag = true;
                    }
                    curr.isRepairMag = true;
                }
            }
        }
    },
    OrderStep(orderStatus) { // 订单状态转换顶端导航步骤序号
        let sp = 1;
        const os = orderStatus;
        if (os === 0) { sp = 0; }
        if (os === 30) { sp = 1; }
        if (os === 40) { sp = 2; }
        if (os === 50) { sp = 3; }
        if (os === 100) { sp = 5; }
        return sp;
    },
    CountOrderTotalAmount(currOrder) {
        // 统一价格计算
        // 金额 × 100防止误差，最后结果必须 除以 100
        let order_amount = 0.00; //订单金额
        let total_amount = 0.00; //不含已付实物总金额
        let over_order_total_amount = 0.00; //完结订单的总金额
        let nodeduction_waitpay = 0.0; //不考虑抵扣待支付金额
        let waitpay = 0.0; //算抵扣待支付金额
        let deduction = 0.00; //抵扣金额
        const ods = currOrder.ViewItems;
        for (const odidx in ods) {
            const od = ods[odidx];
            for (const oit of od) {
                let t_p = oit.Price * 100; //单项
                order_amount += t_p;
                if (oit.SkuType === 1) { //实物
                    if (oit.IsLastPay === 1) { //后支付实物计算入总金额
                        over_order_total_amount += t_p;
                    }
                    if (oit.PayStatus === 10) { //未支付算入待支付
                        total_amount += t_p;
                        nodeduction_waitpay += t_p;
                        waitpay += t_p;
                    }
                } else if (oit.SkuType === 3) { //服务
                    nodeduction_waitpay += t_p;
                    over_order_total_amount += t_p;
                    waitpay += t_p;
                    total_amount += t_p;
                }

                if (oit.HasServiceCodeDeduction) {
                    waitpay -= t_p;
                    deduction += t_p;
                }
            }
        }
        // 赋值订单待付价格数据，总金额采用服务器总金额
        currOrder.TotalWaitPay = waitpay / 100; //含抵扣待支付金额
        currOrder.DeductionAmount = deduction / 100; //已经抵扣金额
        currOrder.TotalNeedPay = total_amount / 100; //不含已付实物总金额
        currOrder.OverOrderTotalWaitPay = over_order_total_amount / 100; //已完成订单的总金额
    },
    CountOrderItemAmount(currOrderItem) { //单项计算价格
        //单项价格计算
        let oit = currOrderItem;
        let totalprice = 0.0; //总价
        let waitpay = 0.0; //支付总价
        let t_p = oit.Price * 100; //计算价格
        if (oit.SkuType === 1) { //实物
            if (oit.PayStatus === 10) { //未支付算入待支付
                waitpay += t_p;
            }
            totalprice += t_p; //算入总价
        }
        if (oit.SkuType === 3) { //服务
            waitpay += t_p; //算入待支付价格
            totalprice += t_p; //算入总价
        }
        if (oit.HasServiceCodeDeduction) { waitpay - oit.DeductionPrice * 100 }
        if (waitpay < 0.0) { waitpay = 0.0; }
        oit.ItemWaitPayAmount = waitpay / 100;
        oit.ItemTotalAmount = totalprice / 100;
    },
    _CountOrderTotalAmount(currOrder) { //优化版本计算总价(已经转移到后端计算)
        // 统一价格计算
        // 金额 × 100防止误差，最后结果必须 除以 100
        let order_total_amount = 0.00; //订单总金额
        let total_wait_pay = 0.00; //订单总待付
        let total_discount = 0.00; //总优惠
        let total_deduction = 0.00; //总抵扣
        const ods = currOrder.ViewItems;
        for (const odidx in ods) {
            const od = ods[odidx];
            for (const oit of od) {
                let t_p = oit.Price * 100; //单项
                let d_a = oit.DiscountAmount * 100; //每项优惠
                total_discount += d_a;
                if (oit.SkuType === 1) { //实物
                    if (oit.IsLastPay === 1) { //后支付
                    }
                    if (oit.PayStatus === 10) { //未支付
                        order_total_amount += t_p;
                    }
                } else if (oit.SkuType === 3) { //服务
                    order_total_amount += t_p;
                    if (oit.HasServiceCodeDeduction) { // 服务核销
                        total_deduction += t_p;
                    } else { //服务未核销
                    }
                }
            }
        }
        // 付款页面
	    currOrder.WaitPayTotal = order_total_amount/100;
	    currOrder.WaitPayTotalDeduction = total_deduction/100;
	    currOrder.WaitPayTotalDiscount = (currOrder.ProductDiscountAmount*100 + currOrder.ServiceDiscountAmount*100 + currOrder.OrderDiscountAmount*100+currOrder.CouponAmount*100)/100;
	    currOrder.WaitPayTotalWaitPay = (order_total_amount - total_deduction - currOrder.WaitPayTotalDiscount*100)/100;
	    if(currOrder.WaitPayTotalWaitPay<=0){
	      currOrder.WaitPayTotalWaitPay = 0.00;
	    }
	    // 维修台页面
	    currOrder.RepairPlatformTotal = order_total_amount/100;
	    currOrder.RepairPlatformTotalDeduction = total_deduction/100;
	    currOrder.RepairPlatformTotalDiscount = (currOrder.ProductDiscountAmount*100 + currOrder.ServiceDiscountAmount*100 + currOrder.OrderDiscountAmount*100)/100;
	    currOrder.RepairPlatformTotalWaitPay = (order_total_amount - total_deduction - currOrder.WaitPayTotalDiscount*100)/100;
	    if(currOrder.RepairPlatformTotalWaitPay<=0){
	      currOrder.RepairPlatformTotalWaitPay = 0.00;
	    }
    },
    // 判断是否是钉钉
    isDing() {
        const userAgent = window.navigator.userAgent;

        return ((/AliApp/.test(userAgent) || /dingtalk-win/.test(userAgent)) && /DingTalk/.test(userAgent));
    },
    // 钉钉鉴权
    DDAuthor(ddUrl,callbackName,params) {

        if(callbackName.indexOf("openLink​")!=-1){
            var linkurl= params
            dd.ready(function() {
                dd.biz.util.openLink({
                    url:linkurl,//要打开链接的地址
                    onSuccess : function(result){},
                    onFail : function(err){}
                })
             })
        }

        else{
        //var passUrl = ddUrl+"?"+new Date().getTime()
        var passUrl = ddUrl
        //alert("http://"+window.location.hostname+":8080");
        if (ddUrl.indexOf("#") != -1) {
            passUrl = ddUrl.substring(0, ddUrl.indexOf("#"))
        }

        if (passUrl.indexOf("login") == -1 && passUrl.indexOf("logout") == -1
            && passUrl.indexOf("LoginCallBack") == -1
            && passUrl.indexOf("home") == -1 )
         {
              userApi.GetDDAuthority({ url: passUrl }).then(res => {
                var result = JSON.parse(res.Data);
                dd.config({
                    agentId: result.agentId, // 必填，微应用ID
                    corpId: result.corpId, //必填，企业ID
                    timeStamp: result.sTimeStamp, // 必填，生成签名的时间戳
                    nonceStr: result.nonceStr, // 必填，生成签名的随机串
                    signature: result.signature, // 必填，签名
                    jsApiList: [
                        'runtime.info',
                        'device.notification.prompt',
                        'biz.chat.pickConversation',
                        'device.notification.confirm',
                        'device.notification.alert',
                        'device.notification.prompt',
                        'biz.chat.open',
                        'biz.util.open',
                        'biz.user.get',
                        'biz.contact.choose',
                        'biz.telephone.call',
                        'biz.telephone.showCallMenu',
                        'biz.util.uploadImage',
                        'biz.ding.post']
                });
                // 查看鉴权错误信息
                if(callbackName.indexOf("showCallMenu")!=-1){
                   var phone=params
                    dd.ready(function() {
                        dd.biz.telephone.showCallMenu({
                          phoneNumber:phone, // 期望拨打的电话号码
                          code: '+86', // 国家代号，中国是+86
                          showDingCall: true, // 是否显示钉钉电话
                          onSuccess : function() {

                          },
                          onFail : function(ev) {

                            alert("电话拨打异常"+JSON.stringify(ev))
                          }
                      })
                      })
                }
               else if(callbackName.indexOf("scanQrCode")!=-1){
                   var callBack= params
                dd.ready(function() {
                    dd.biz.util.scan({
                       type: "qrCode" , // type 为 all、qrCode、barCode，默认是all。
                       onSuccess: function(data) {
                         callBack(data.text);

                       //onSuccess将在扫码成功之后回调
                         /* data结构
                           { 'text': String}
                         */
                       },
                      onFail : function(err) {
                       alert('调用扫码失败：仅支持安卓和IOS！');
                      }
                   })
                 })
                }

            });
        }
            dd.error(function (err) {
                //alert('dd error: ' + JSON.stringify(err));
              //window.location.href=ddUrl;
              // DDAuthor(window.location.href,callbackName,params)
            });
        }
    }
}
// 时间扩展方法
Date.prototype.AddDays = function(day) {
    let cday_ms = day * 24 * 60 * 60 * 1000;
    let ctime = this.getTime();
    let new_time = new Date(ctime + cday_ms);
    return new_time;
}
Date.prototype.AddHours = function(hour) {
    let chour_ms = hour * 60 * 60 * 1000;
    let ctime = this.getTime();
    let new_time = new Date(ctime + chour_ms);
    return new_time;
}
Date.prototype.ToStr = function() {
        let dt = this;
        return `${dt.getFullYear()}-${dt.getMonth()+1}-${dt.getDate()} ${dt.getHours()}:${dt.getMinutes()}:${dt.getSeconds()}`;
    }
Date.prototype.ToDateStr = function(){
    let dt = this;
    let month = dt.getMonth()+1;
    month = month.toString();
    if(month.length === 1) month = "0" + month.toString();
    return `${dt.getFullYear()}-${month}-${dt.getDate()}`;
}
    // 字符串扩展方法
String.prototype.RemoveRight = function(tag) {
    let s = this;
    let len = s.length;
    let lastpos = s.lastIndexOf(tag);
    return s.substr(0, lastpos);
}
String.prototype.RemoveLeft = function(tag) {
    let s = this;
    let len = s.length;
    let lastpos = s.indexOf(tag);
    return s.substr(lastpos, len - lastpos);
}
String.prototype.trim = function() {
        return this.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    // 数值扩展方法
Number.prototype.ToMoney = function() {
    return this.toFixed(2);
}



// WEBPACK FOOTER //
// ./src/common/utils.js